import {Stack} from 'shells/layout/stack/stack';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {PopoverInfo} from 'shells/popover-info/popover-info';
import {RelativeTimestamp} from 'shells/timestamp/relative-timestamp';
import {RELATIVE_TIMESTAMP_FORMATS} from 'shells/timestamp/types';
import {Body} from 'shells/typography/body';

import {DataFieldWrapper} from '../../../core-entity/widgets/summary-widget/data-field-wrapper';

import type {PeepType} from '../../types';

import {PeepLastContactedPopoverContent} from '../header/edit-fields/peep-last-contacted-popover-content';

interface Props {
    entityType: PeepType;
    lastContactedTime: number | null;
    myLastContactedTime: number | null;
    isLoadingPeepLastContact: boolean;
}

export function PeepLastContacted(props: Props) {
    const entityString = props.entityType === 'contact' ? 'person' : 'company';

    let EditFieldWrapperContent = null;
    if (props.isLoadingPeepLastContact) {
        EditFieldWrapperContent = (
            <div className='px-4'>
                <LoadingText height={16} width={106} />
            </div>
        );
    } else {
        EditFieldWrapperContent = (
            <Stack isHorizontal={true} spacing={0}>
                {props.lastContactedTime ? (
                    <>
                        <RelativeTimestamp
                            datetime={props.lastContactedTime}
                            format={RELATIVE_TIMESTAMP_FORMATS.FROM_NOW}
                            className='font-size-normal'
                        />
                        <PopoverInfo
                            info={
                                <PeepLastContactedPopoverContent
                                    entityString={entityString}
                                    lastContactedTime={props.lastContactedTime}
                                    myLastContactedTime={props.myLastContactedTime}
                                />
                            }
                            shouldFadeIn={true}
                            useInfoRegularIcon={true}
                            variant='greyLt'
                            size={18}
                        />
                    </>
                ) : (
                    <Body>No one has contacted this {entityString}</Body>
                )}
            </Stack>
        );
    }

    return <DataFieldWrapper label='Last contacted' children={EditFieldWrapperContent} />;
}
